import { Grid, Stack, Typography } from '@mui/material';

import { ATTACHMENT_FIELD_NAME, REQUIRED_ATTACHMENTS } from '~common';
import { ZonePhotoUpload } from '~components/molecules';
import { IPreviewFile } from '~hooks/upload-file';
import { CameraProvider } from '~providers/CameraProvider';

type Props = {
  initAttachmentFiles?: Record<ATTACHMENT_FIELD_NAME, IPreviewFile>;
  handleUploadPhoto: (
    fieldName: ATTACHMENT_FIELD_NAME,
  ) => (file: IPreviewFile) => void;
  handleRemovePhoto: (fieldName: ATTACHMENT_FIELD_NAME) => () => void;
  imei: string;
};

export const UploadPhotosStep: React.FC<Props> = ({
  initAttachmentFiles,
  handleUploadPhoto,
  handleRemovePhoto,
  imei,
}) => {
  return (
    <Grid container alignItems={'flex-start'} spacing={3} pb={15}>
      <Grid item xs={12}>
        <Typography fontSize="1.25rem" fontWeight={600} color="text.primary">
          IMEI: {imei}
        </Typography>
      </Grid>
      {REQUIRED_ATTACHMENTS.map((photo, index) => (
        <Grid item key={index} xs={6}>
          <CameraProvider
            fileUploadedCallback={handleUploadPhoto(photo.fieldName)}
            fileRemovedCallback={handleRemovePhoto(photo.fieldName)}
            caption={photo.caption}
            description={photo.description}
            isLandscapeView={
              photo.fieldName === ATTACHMENT_FIELD_NAME.stationPerspective
            }
            initialImage={initAttachmentFiles?.[photo.fieldName]}
          >
            <Stack gap={1}>
              <ZonePhotoUpload />

              <Stack alignItems="flex-start">
                <Typography fontSize="1rem" fontWeight={600}>
                  {photo.caption}{' '}
                  {!photo.optional && (
                    <Typography
                      variant="body1"
                      component="span"
                      color="error.main"
                    >
                      *
                    </Typography>
                  )}
                </Typography>
                <Typography fontSize="0.875rem" color="text.placeholder">
                  {photo.description}
                </Typography>
              </Stack>
            </Stack>
          </CameraProvider>
        </Grid>
      ))}
    </Grid>
  );
};
